module.exports = __webpack_public_path__ + "static/img/sjfz.b7386e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjfz.png
// module id = 30qM
// module chunks = 0